import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Site-wide CTA block. Matches the Home page final CTA exactly
 * so every page ends with the same visual language.
 */
export default function CTASection({
  title = "Let's talk about your business.",
  primary = { label: "Let's have a chat", to: "/contact" },
  secondary = { label: "Meet the team", to: "/team" },
  lead = "Whether you already know what you need or you're just looking for another perspective, we'd love to hear about your business.",
}) {
  return (
    <section className="ob-section" style={{ background: "var(--ob-bg-panel)" }} data-testid="cta-section">
      <div className="ob-container">
        <div className="max-w-4xl">
          <h2 className="ob-h1">{title}</h2>
          {lead && <p className="ob-lead mt-10 max-w-2xl">{lead}</p>}
          <div className="mt-12 flex flex-wrap gap-3">
            <Link to={primary.to} className="ob-btn ob-btn-primary h-12" data-testid="cta-primary">
              {primary.label}
              <ArrowUpRight size={16} strokeWidth={1.5} className="ml-1" />
            </Link>
            <Link to={secondary.to} className="ob-btn h-12" data-testid="cta-secondary">
              {secondary.label}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
